document.addEventListener('DOMContentLoaded', function() {
  const wishlistButtons = document.querySelectorAll('.add-to-wishlist');
  const wishlistCounter = document.querySelectorAll('.wishlist-counter');

  // Function to get wishlist from localStorage
  function getWishlist() {
    return JSON.parse(localStorage.getItem('wishlist')) || [];
  }

  // Function to save wishlist to localStorage
  function saveWishlist(wishlist) {
    try {
      localStorage.setItem('wishlist', JSON.stringify(wishlist));
    } catch (e) {
      console.error('Could not save wishlist to localStorage:', e);
    }
  }

  // Function to add product to wishlist
  function addToWishlist(productId, button) {
  let wishlist = getWishlist();
  let tooltip = button.closest('.product-card__information').querySelector('.tooltip-advice'); // Use querySelector to ensure it's properly selected

    // Check if the tooltip exists, and if not, create it
    if (!tooltip) {
      tooltip = document.createElement('div');
      tooltip.classList.add('tooltip-advice');
      button.closest('.product-card__information').appendChild(tooltip); // Add tooltip to the button
    }

    // Add to wishlist if not already there
    if (!wishlist.includes(productId)) {
      wishlist.push(productId);
      saveWishlist(wishlist);
      updateButtonStyles();
      tooltip.innerHTML = '<p>Product has been added to your Wishlist!</p>';
      tooltip.classList.add("active");
      tooltip.setAttribute('aria-live', 'assertive'); // For screen readers
      tooltip.setAttribute('role', 'alert'); // Ensures screen reader will announce it

      // Hide the tooltip after 2 seconds
      setTimeout(() => {
        tooltip.classList.remove("active");
        tooltip.removeAttribute('aria-live');
        tooltip.removeAttribute('role'); // Clean up the role attribute
      }, 2000);
    } else {
      removeFromWishlist(productId);
    }
  }

  // Function to remove product from wishlist
  function removeFromWishlist(productId) {
    let wishlist = getWishlist();
    if (wishlist.includes(productId)) {
      wishlist = wishlist.filter(id => id !== productId);
      saveWishlist(wishlist);
      updateButtonStyles();
      updateWishlistPage();
    }
  }

  // Function to update the styles of wishlist buttons
    function updateButtonStyles() {
    const wishlist = getWishlist();
    
    // Update all the wishlist buttons
    wishlistButtons.forEach(button => {
      const productId = button.getAttribute('data-product-id');

      if (wishlist.includes(productId)) {
        button.classList.add('active');
        button.setAttribute('aria-label', 'Remove from wishlist');
      } else {
        button.classList.remove('active');
        button.setAttribute('aria-label', 'Add to wishlist');
      }
    });


    // Update the wishlist counters only if the elements exist
    const count = wishlist.length > 0 ? wishlist.length : '0';

    if (wishlistCounter.length > 0) {
      wishlistCounter.forEach(counter => {
        counter.innerHTML = count;
      });
    }
  }


  // Event listeners for adding items to wishlist
  wishlistButtons.forEach(button => {
    button.addEventListener('click', function(event) {
      event.preventDefault();
      const productId = this.getAttribute('data-product-id');
      addToWishlist(productId, button);
    });
  });

  // Function to attach remove event listeners dynamically
  function attachRemoveEventListeners() {
    const removeWishlistButtons = document.querySelectorAll('.add-to-wishlist.active');
    removeWishlistButtons.forEach(button => {
      button.addEventListener('click', function(event) {
        event.preventDefault();
        const productId = this.getAttribute('data-product-id');
        removeFromWishlist(productId);
      });
    });
  }

  // Function to update the wishlist page
  function updateWishlistPage() {
    const wishlistContainer = document.getElementById('wishlist-products');
    if (!wishlistContainer) return;

    const wishlist = getWishlist();
    wishlistContainer.innerHTML = '';

    if (wishlist.length > 0) {
      wishlist.forEach(productId => {
        fetch(`/products/${productId}.json`)
          .then(response => {
            if (!response.ok) throw new Error('Network response was not ok');
            return response.json();
          })
          .then(data => {
            const product = data.product;
            const variant = product.variants[0];
            const available = variant.available;
            const price = variant.price;
            const compareAtPrice = variant.compare_at_price;
            const unitPrice = variant.unit_price;
            const unitPriceMeasurement = variant.unit_price_measurement;
            const currencyCode = Shopify.currency?.active;

            const isOnSale = compareAtPrice && compareAtPrice > price;
            const hasUnitPrice = unitPrice && unitPriceMeasurement;

            const formattedPrice = new Intl.NumberFormat(undefined, {
              style: 'currency',
              currency: currencyCode
            }).format(price);

            const priceClasses = `
              f-price f-price--left
              ${!available ? 'f-price--sold-out' : ''}
              ${isOnSale ? 'f-price--on-sale' : ''}
            `.trim();

            const regularPriceHTML = `
              <div class="f-price__regular">
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span class="f-price-item f-price-item--regular">${formattedPrice}</span>
              </div>
            `;

            const salePriceHTML = isOnSale ? `
              <div class="f-price__sale">
                <span class="visually-hidden visually-hidden--inline">Sale price</span>
                <span class="f-price-item f-price-item--sale">${formattedPrice}</span>
                <span class="visually-hidden visually-hidden--inline">Regular price</span>
                <span>
                  <s class="f-price-item f-price-item--regular">${formattedPrice}</s>
                </span>
              </div>
            ` : '';

            const unitPriceHTML = hasUnitPrice ? `
              <div class="f-price__unit-wrapper">
                <span class="visually-hidden">Unit price</span>
                <div class="f-price__unit">
                  <span data-unit-price>${(unitPrice / 100).toFixed(2)}</span>
                  <span aria-hidden="true">/</span>
                  <span class="visually-hidden">per&nbsp;</span>
                  <span data-unit-price-base-unit>
                    ${unitPriceMeasurement.reference_value !== 1 ? unitPriceMeasurement.reference_value : ''}
                    ${unitPriceMeasurement.reference_unit}
                  </span>
                </div>
              </div>
            ` : '<div class="f-price__unit-wrapper hidden"></div>';

            const badgeHTML = isOnSale ? `
              <div class="f-price__badges">
                <div class="f-price__badge-sale" data-type="percentage">
                  <span class="f-badge f-badge--sale">
                    Save ${Math.round(((compareAtPrice - formattedPrice) / compareAtPrice) * 100)}%
                  </span>
                </div>
              </div>
            ` : '';

            const productHtml = `
              <div class="f-column">
                <div class="product-card grid-list__column">
                  <div class="product-card__wrapper">
                    <a 
                      href="/products/${product.handle}?variant=${product.variants[0].id}" 
                      class="full-width-link product-card__link"
                    >
                      <span class="visually-hidden">${product.title}</span>
                    </a>
                    <div class="product-card__image-wrapper f-card">
                      <responsive-image 
                        class="f-image product-card__image product-card__image--main" 
                        style="--aspect-ratio: 3/4" intersecting="true"
                      >
                        <img
                          srcset="${product.images[0].src}"
                          src="${product.images[0].src}"
                          alt="${'Product image for ' + product.images[0].alt ? product.images[0].alt : product.title}"
                          class="motion-reduce f-img-loaded" 
                          loading="eager" 
                          fetchpriority="high" 
                          width="291" 
                          height="388"
                        >
                      </responsive-image>
                      ${product.images[1] && product.images[1].src ? `
                        <responsive-image
                          class="f-image f-image--no-zoom product-card__image product-card__image--second inset-full hidden md:block"
                          data-image-loading
                          style="--aspect-ratio: 3/4" intersecting="true"
                        >
                          <img
                            srcset="${product.images[1].src}"
                            src="${product.images[1].src}"
                            alt="${product.images[0].alt ? 'Product image for ' + product.images[0].alt : 'Product image for ' + product.title}"
                            class="motion-reduce f-img-loaded" 
                            loading="eager" 
                            fetchpriority="high" 
                            width="291" 
                            height="388"
                          >
                        </responsive-image>
                      ` : ''}
                    </div>

                    <div class="product-card__info text-left">
                      <div class="product-card__information">
                        <h3 class="product-card__title text-product-title font-heading">
                          ${product.title}
                        </h3>
                        
                        <button 
                          aria-labelledby="wishlist-label-${productId}" 
                          class="add-to-wishlist active" 
                          data-product-id="${productId}"
                          aria-label="Remove ${product.title} from wishlist"
                        >
                          <svg viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg" class="f-icon-svg f-icon-svg--medium">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M21.0002 8.97903C21.0002 15.2234 12.0006 20.479 12.0006 20.479C12.0006 20.479 3.00024 15.1457 3.00024 8.99169C3.00024 6.47903 5.00024 4.47903 7.50024 4.47903C10.0002 4.47903 12.0002 7.47903 12.0002 7.47903C12.0002 7.47903 14.0002 4.47903 16.5002 4.47903C19.0002 4.47903 21.0002 6.47903 21.0002 8.97903Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                          </svg>
                        </button>
                      </div>
                      ${product.vendor !== '' ? `
                        <span class="product-card__vendor">
                          ${product.vendor}
                        </span>
                      ` : ''}
                      
                      <div class="${priceClasses}">
                        ${regularPriceHTML}
                        ${salePriceHTML}
                        ${unitPriceHTML}
                        ${badgeHTML}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            `;

            wishlistContainer.insertAdjacentHTML('beforeend', productHtml);
          })
          .catch(error => console.error('There was a problem with the fetch operation:', error))
          .finally(() => attachRemoveEventListeners());
      });
    } else {
      wishlistContainer.innerHTML = '<p>Your wishlist is empty.</p>';
    }
  }

  // Initial call to update wishlist page and button styles
  updateWishlistPage();
  updateButtonStyles();
});